import{jsx as t}from"react/jsx-runtime";const e=({text:e,className:a=""})=>t("div",{className:`text-2xl font-bold ${a}`,children:e});export{e as default};
